/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';

import BaseWizard from 'containers/BaseWizard';
import NumberedSidebar from 'containers/BaseWizard/components/Sidebars/NumberedSidebar';

import ExamplePage from './ExamplePage';

const PATH = 'Path One';
const cancelModalProps = {
  title: `${PATH} Modal`
};

const WizardPathOne = ({ wizardStore, handleClose, resetPath }) => {
  return (
    <BaseWizard
      enableFooter
      cancelModalProps={cancelModalProps}
      enableCancelModal
      wizardStore={wizardStore}
      sidebarComponent={<NumberedSidebar title={`${PATH} Sidebar`} />}
      onClose={handleClose}
    >
      <ExamplePage
        title={`${PATH} Page One`}
        pageHeader={`${PATH} Page One Header`}
        onFooterBack={resetPath}
      />
      <ExamplePage
        title={`${PATH} Page Two but this is longer and wraps`}
        pageHeader={`${PATH} Page Two Header`}
      />
      <ExamplePage
        title={`${PATH} Page Three`}
        pageHeader={`${PATH} Page Three Header`}
      />
    </BaseWizard>
  );
};

WizardPathOne.propTypes = {
  wizardStore: PropTypes.object,
  handleClose: PropTypes.func,
  resetPath: PropTypes.func
};

export default WizardPathOne;
